/** Internal dependencies */
export function loadHbstmpl(element) {
  var source = element.innerHTML;
  var key = element.getAttribute("data-id");
  var sourcePrepped = eval("(function(){return " + source + "}());"); // this is not nice but needed -.-
  Handlebars.partials[key] = Handlebars.template(sourcePrepped);
}
